import { useState, useEffect } from "react";
import React from "react";
import { API_BASE_URL } from "../config/api";

const initialState = {
  name: "",
  email: "",
  phone: "",
  topic: "",
  message: ""
};

const translations = {
  tr: {
    title: "BİZİMLE İLETİŞİME GEÇ",
    alerts: {
      success: "Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapılacaktır.",
      error: "Hata: İstek başarısız oldu. Lütfen daha sonra tekrar deneyin.",
      generalError: "Bir hata oluştu: "
    },
    placeholders: {
      name: "Ad Soyad",
      phone: "Telefon",
      email: "E-posta",
      topic: "Konu",
      message: "Mesajınız"
    },
    buttons: {
      submit: "Mesaj Gönder",
      submitting: "Gönderiliyor..."
    },
    modal: {
      success: "Başarılı!",
      error: "Hata!",
      closing: "10 saniye içinde kapanacak...",
      close: "Kapat"
    }
  },
  en: {
    title: "GET IN TOUCH WITH US",
    alerts: {
      success: "Your message has been sent successfully! We will get back to you as soon as possible.",
      error: "Error: Request failed. Please try again later.",
      generalError: "An error occurred: "
    },
    placeholders: {
      name: "Full Name",
      phone: "Phone",
      email: "Email",
      topic: "Subject",
      message: "Your Message"
    },
    buttons: {
      submit: "Send Message",
      submitting: "Sending..."
    },
    modal: {
      success: "Success!",
      error: "Error!",
      closing: "Will close in 10 seconds...",
      close: "Close"
    }
  },
  fr: {
    title: "PRENEZ CONTACT AVEC NOUS",
    alerts: {
      success: "Votre message a été envoyé avec succès! Nous vous répondrons dès que possible.",
      error: "Erreur: La demande a échoué. Veuillez réessayer plus tard.",
      generalError: "Une erreur s'est produite: "
    },
    placeholders: {
      name: "Nom Complet",
      phone: "Téléphone",
      email: "E-mail",
      topic: "Sujet",
      message: "Votre Message"
    },
    buttons: {
      submit: "Envoyer",
      submitting: "Envoi en cours..."
    },
    modal: {
      success: "Succès!",
      error: "Erreur!",
      closing: "Se fermera dans 10 secondes...",
      close: "Fermer"
    }
  }
};

// Modal Component
const ModalComponent = ({ modal, setModal, isDarkMode, t }) => {
  if (!modal.show) return null;

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex",
      justifyContent: "center", alignItems: "center", zIndex: 9999
    }}>
      <style>{`
        @keyframes slideIn {
          from { transform: translateY(-50px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes progressBar {
          from { width: 100%; }
          to { width: 0%; }
        }
        .modal-container { animation: slideIn 0.3s ease-out; }
      `}</style>
      <div className="modal-container" style={{
        backgroundColor: isDarkMode ? "#1a1a1a" : "#fff",
        borderRadius: "10px", padding: "40px", maxWidth: "500px", width: "90%",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", textAlign: "center"
      }}>
        <div style={{
          fontSize: "60px",
          color: modal.type === "success" ? "#4CAF50" : "#f44336",
          marginBottom: "20px"
        }}>
          {modal.type === "success" ? "✓" : "⚠"}
        </div>
        <h2 style={{
          color: modal.type === "success" ? "#4CAF50" : "#f44336",
          marginBottom: "15px", fontSize: "24px"
        }}>
          {modal.type === "success" ? t.modal.success : t.modal.error}
        </h2>
        <p style={{
          color: isDarkMode ? "#bbb" : "#666",
          fontSize: "16px", lineHeight: "1.6", marginBottom: "20px"
        }}>
          {modal.message}
        </p>
        <div style={{
          width: "100%", height: "4px",
          backgroundColor: isDarkMode ? "#333" : "#e0e0e0",
          borderRadius: "2px", overflow: "hidden", marginTop: "20px"
        }}>
          <div style={{
            height: "100%",
            backgroundColor: modal.type === "success" ? "#4CAF50" : "#f44336",
            animation: "progressBar 10s linear forwards"
          }}></div>
        </div>
        <p style={{ color: "#999", fontSize: "12px", marginTop: "10px" }}>
          {t.modal.closing}
        </p>
        <button
          onClick={() => setModal({ show: false, type: "", message: "" })}
          style={{
            marginTop: "20px", padding: "10px 30px",
            backgroundColor: modal.type === "success" ? "#4CAF50" : "#f44336",
            color: "#fff", border: "none", borderRadius: "5px",
            cursor: "pointer", fontSize: "14px", fontWeight: "bold", transition: "opacity 0.3s"
          }}
          onMouseOver={(e) => e.target.style.opacity = "0.8"}
          onMouseOut={(e) => e.target.style.opacity = "1"}
        >
          {t.modal.close}
        </button>
      </div>
    </div>
  );
};

export const Contact = (props) => {
  const [{ name, email, phone, topic, message }, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState({ show: false, type: "", message: "" });
  const [isDarkMode, setIsDarkMode] = useState(false);

  const lang = (props.lang || "tr").toLowerCase();
  const t = translations[lang] || translations["tr"];

  // Dark mode kontrolü
  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains('dark-mode'));
    };
    checkDarkMode();

    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  // Modal otomatik kapat (10 saniye)
  useEffect(() => {
    if (modal.show) {
      const timer = setTimeout(() => {
        setModal({ show: false, type: "", message: "" });
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [modal.show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const showModal = (type, message) => {
    setModal({ show: true, type, message });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const contactData = {
      name,
      email,
      phoneNumber: phone,
      topic,
      message,
      language: lang
    };

    try {
      const response = await fetch(`${API_BASE_URL}/api/contactform/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(contactData)
      });

      if (response.ok) {
        showModal("success", t.alerts.success);
        clearState();
      } else {
        showModal("error", t.alerts.error);
      }
    } catch (error) {
      showModal("error", t.alerts.generalError + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <ModalComponent modal={modal} setModal={setModal} isDarkMode={isDarkMode} t={t} />

      <div id="contact">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="section-title">
                <h2>{t.title}</h2>
                <p></p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder={t.placeholders.name}
                        value={name}
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className="form-control"
                        placeholder={t.placeholders.phone}
                        value={phone}
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder={t.placeholders.email}
                        value={email}
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="topic"
                        name="topic"
                        className="form-control"
                        placeholder={t.placeholders.topic}
                        value={topic}
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        id="message"
                        className="form-control"
                        rows="4"
                        placeholder={t.placeholders.message}
                        value={message}
                        required
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-custom btn-lg"
                    disabled={isLoading}
                  >
                    {isLoading ? t.buttons.submitting : t.buttons.submit}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};